import axios from 'axios'
import store from '@/store'
import { websocketService } from '@/services/WebsocketService'
import { createRefreshRegistry } from './refresh-registry'

// Версия выборки заказов с теми же параметрами, что у списка. Интерцепторы axios сами
// подставят токен и текущий филиал
function fetchVersion (params) {
  return axios
    .get(store.getters['api/ordersVersion'], { params })
    .then((res) => res.data.data.version)
}

// Сокет получает реестр параметром в init, а не импортом: иначе модули
// импортировали бы друг друга по кругу
export const refreshService = createRefreshRegistry({
  ensureConnected: () => websocketService.ensureConnected(),
  fetchVersion,
  onServerUnavailable: (unavailable) => store.commit('network/setServerUnavailable', unavailable),
})
